import React, { useState } from 'react';
import { IconButton, Snackbar } from '@material-ui/core';
import FileCopyIcon from '@material-ui/icons/FileCopy';

function CopyButton({ text }) {
  const [open, setOpen] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setOpen(true);
    } catch (err) {
      console.error('Erreur lors de la copie :', err);
    }
  };

  const handleClose = (_, reason) => {
    if (reason === 'clickaway') return;
    setOpen(false);
  };

  return (
    <>
      <IconButton
        color="primary"
        size="small"
        onClick={handleCopy}
        style={{ padding: 4 }} 
        title="Copier" //
      >
        <FileCopyIcon fontSize="small" /> {/* icône plus petite */}
      </IconButton>

      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        open={open}
        autoHideDuration={2000}
        onClose={handleClose}
        message="Copié !"
      />
    </>
  );
}

export default CopyButton;
